import { ErrorMessage } from '@hookform/error-message';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';
import ErrorMessageText from '../ErrorMessageText';
import Label from '../Label';
import { SFormGroup } from './styles';

interface ToggleInputProps {
    control: any;
    name: string;
    label?: string;
    required?: boolean;
    semi?: boolean;
    helper?: string;
    defaultValue?: boolean;
    disabled?: boolean;
    isPremiumFeature?: boolean;
}

const ToggleInput: FC<ToggleInputProps> = ({
    control,
    label,
    defaultValue,
    name,
    required = false,
    semi,
    helper,
    disabled,
    isPremiumFeature = false,
}) => {
    const { t } = useTranslation();
    const {
        formState: { errors },
        setValue,
    } = useFormContext();

    return (
        <Controller
            // TODO get control with react hook form provider
            control={control}
            defaultValue={defaultValue}
            name={name}
            render={({ field: { onChange, value, ...rest } }) => (
                <SFormGroup semi={semi} withError={!!errors[name]}>
                    {label && (
                        <Label helper={helper} isPremiumFeature={isPremiumFeature} name={name} required={required} text={label} />
                    )}
                    <Toggle
                        {...rest}
                        defaultChecked={value ?? defaultValue}
                        disabled={disabled}
                        onChange={(val) => {
                            if (!val) {
                                setValue(name, false);
                            }
                            onChange(val.target.checked ?? false);
                        }}
                    />
                    {errors[name] && (
                        <ErrorMessage
                            errors={errors}
                            name={name}
                            render={({ message }) => <ErrorMessageText text={message} />}
                        />
                    )}
                </SFormGroup>
            )}
            rules={{ required: required ? `${t('common.required-field')}` : false }}
        />
    );
};

export default ToggleInput;
